<div class="container-fluid">
    <div class="row">
        <div class="col-12 mt-4">
          <h3> <b> Notifications</b></h3>  
            <p style="color: #6D6D6D;"> decide what you want to be notified  abou and unsubscribe  from what you dont't</p>
        </div>
        
    </div>
    <div class="row">
        <div class="col-10 d-flex justify-content-between  lnotification">
            <div> 
            <p style="font-weight: 400;"> Local Notification</p>
            <p style="color: #6D6D6D;"> Send push notification within this web app</p>
            </div>
            <div class="d-flex justify-content-center    align-items-center">
                <label class="switch">
                    <input type="checkbox">
                    <span class="slider round"></span>
                  </label> </div>
            
              
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-10 d-flex justify-content-between  lnotification">
            <div> 
            <p style="font-weight: 400;"> Email Notification</p>
            <p style="color: #6D6D6D;"> Receive  notification on registered Email Adress</p>
            </div>
            <div class="d-flex justify-content-center    align-items-center">
                <label class="switch">
                    <input type="checkbox">
                    <span class="slider round"></span>
                  </label> </div>
            
              
        </div>
    </div>
</div>
